import { createContext, useContext, useEffect, useState } from "react";

export const STRINGS = {
  nl: {
    heroEyebrow: "Creatief marketingbureau in Nederland",
    navAbout: "Over ons",
    navServices: "Diensten",
    navCases: "Projecten",
    navTestimonial: "Wat klanten zeggen",
    navBook: "Plan een gesprek",
    navFaq: "FAQ",
    heroL1: "Wij maken marketing die werkt,",
    heroL2: "en automatiseren de rest.",
    heroL3: "Geen resultaat? Geen factuur.",
    heroSub:
      "Van resultaatgerichte marketing tot slimme software-koppelingen. Wij combineren creativiteit, technologie en automatisering om jouw bedrijf te laten groeien.",
    ctaServices: "Bekijk onze diensten",
    viewService: "Bekijk dienst",
    ctaIntro: "Plan een kennismaking",
    heroFormTitle: "Direct contact",
    heroFormSub: "We nemen binnen één werkdag contact op.",
    callNow: "Bel nu",
    whatsappUs: "WhatsApp ons",
    statClients: "klanten geholpen",
    statClientsNote: "Van lokale ondernemers tot grote spelers",
    statReach: "bereik & engagement op social media",
    statReachNote: "Gecombineerde track record · freelance + 4thscenery",
    marquee: ["Creatieve content", "Website & SEO", "Automatisering", "Minder handwerk", "Marketing die werkt"],
    chAbout: "Over ons",
    aboutHeadingA: "Wij testen alles",
    aboutHeadingB: "eerst op onszelf",
    aboutCopy1:
      "4thscenery is een klein, hands-on team. Geen lagen van accountmanagers en geen eindeloze rapporten. Wij bouwen, testen en verbeteren zelf. Alles wat we bij klanten inzetten, draait eerst binnen ons eigen bedrijf. Zo weten we zeker dat het werkt.",
    aboutCopy2:
      "Gemiste oproep? Bij ons krijgt de beller direct automatisch een sms terug. Zo wordt iedere potentiële klant direct opgevolgd en voorkom je dat waardevolle leads verloren gaan. Hetzelfde systeem kunnen we volledig voor jouw organisatie inrichten en koppelen aan bestaande B2B-software.",
    aboutChecks: [
      "Directe automatische opvolging",
      "Nooit meer onnodig een lead missen",
      "Koppelbaar met bestaande B2B-software",
    ],
    smsSystemLabel: "Ons SMS-automatiseringssysteem",
    smsBadge: "Live voorbeeld",
    smsTitle: "Gemiste oproep",
    smsMessage:
      "Hoi! Bedankt voor je telefoontje. We konden even niet opnemen, stuur hier je bericht of plan direct een gesprek, dan komen we er vandaag nog bij je op terug.",
    smsAuto: "Automatisch verzonden · 4thscenery",
    chServices: "Diensten",
    servicesHeading: "Marketing, automatisering & B2B software-integratie",
    servicesIntro:
      "Wij helpen bedrijven groeien met reclamevideo's, online advertenties, conversiegerichte websites en slimme automatiseringen. Van automatische leadopvolging via SMS, WhatsApp en e-mail tot complete B2B software-integraties: wij bouwen systemen die handmatig werk verminderen en ervoor zorgen dat minder leads verloren gaan.",
    servicesLink: "Vraag direct advies",
    services: [
      {
        title: "Reclamevideo's + ads",
        copy: "Video's die blijven hangen en advertenties die de juiste mensen bereiken. Wij schrijven, filmen en targeten, jij krijgt de aanvragen.",
      },
      {
        title: "Website-analyses",
        copy: "Een scherpe audit van je website: wat werkt, wat kost je klanten en wat we direct verbeteren. Je krijgt een concreet plan, geen vaag rapport.",
      },
      {
        title: "Systemen bouwen",
        copy: "Automatiseringen die nooit slapen. Gemiste oproep? Automatische sms. Nieuwe lead? Direct opgevolgd. Jouw agenda vult zichzelf.",
      },
      {
        title: "Conversiegerichte websites",
        copy: "Websites die bezoekers omzetten in aanvragen, gebouwd rond één doel: conversie.",
      },
      {
        title: "Leadopvolging via SMS, WhatsApp & e-mail",
        copy: "Elke lead direct automatisch opgevolgd, op het kanaal dat werkt.",
      },
      {
        title: "B2B software-integraties",
        copy: "Complete koppelingen met je bestaande B2B-software, zodat systemen naadloos samenwerken.",
      },
    ],
    noResult: "Wij nemen het risico,",
    noInvoice: "jij niet.",
    chTestimonial: "Wat klanten zeggen",
    review: "1 review",
    clientOf: "Klant van 4thscenery",
    starsLabel: "5 van 5 sterren",
    chBook: "Plan een gesprek",
    bookHeading: "Plan een gesprek",
    bookCopy:
      "Kies direct een moment dat jou uitkomt. Vijftien minuten, vrijblijvend en concreet. Je loopt altijd weg met een volgende stap.",
    calLoading: "Kalender wordt geladen…",
    calDirect: "Open de planner direct op Cal.com",
    chFaq: "FAQ",
    faqHeading: "Veelgestelde vragen",
    faqCopy: "Staat je vraag er niet bij? Bel, app of mail ons direct.",
    faq: [
      {
        q: "Wat zit er in jullie reclamevideo's + ads?",
        a: "Van concept en script tot filmen en targeting: wij maken video's die blijven hangen en advertenties die de juiste mensen bereiken. Jij krijgt de aanvragen.",
      },
      {
        q: "Wat doet een gemiste-oproep-automatisering precies?",
        a: "Kan jij niet opnemen? Dan krijgt de beller binnen seconden automatisch een sms terug. Zo wordt iedere potentiële klant direct opgevolgd en verlies je geen leads. Het systeem koppelen we aan je bestaande B2B-software.",
      },
      {
        q: "Hoe snel kunnen we starten?",
        a: "We beginnen met een vrijblijvend gesprek van 15 minuten. Daarna weet je precies wat de volgende stap is en wat het oplevert.",
      },
      {
        q: "Werken jullie ook met bedrijven buiten de Randstad?",
        a: "Ja. We werken voor bedrijven in heel Nederland, van kleine lokale ondernemingen tot grote spelers.",
      },
      {
        q: "Wat levert een website-analyse op?",
        a: "Een scherpe audit van je website: wat werkt, wat kost je klanten en wat we direct verbeteren. Je krijgt een concreet plan, geen vaag rapport.",
      },
      {
        q: "Doen jullie ook complete B2B software-integraties?",
        a: "Ja. We bouwen integraties die handmatig werk verminderen, van automatische leadopvolging via SMS, WhatsApp en e-mail tot koppelingen met je bestaande software.",
      },
    ],
    rowCall: "Bel ons",
    fName: "Naam",
    fPhone: "Telefoon",
    fEmail: "E-mail",
    fMsg: "Bericht",
    phName: "Je naam",
    phPhone: "06 12 34 56 78",
    phEmail: "jij@bedrijf.nl",
    phMsg: "Waar kunnen we je mee helpen?",
    submit: "Verstuur bericht",
    sending: "Verzenden...",
    toastOk: "Bedankt! Je bericht is verzonden, we reageren snel.",
    toastErr: "Verzenden mislukt. Probeer het opnieuw of bel ons direct.",
    closingHeading: "Klaar voor de volgende scène?",
    closingCopy: "Bel direct of stuur een WhatsApp, we reageren snel.",
    rights: "Alle rechten voorbehouden.",
    footerTerms: "Algemene voorwaarden",
    widgetBubble: "Hoi! Stuur ons een bericht, meestal reageren we binnen een paar minuten.",
    widgetOnline: "Online",
    widgetStart: "Start chat",
    chatTitle: "4thscenery AI-assistent",
    chatOnline: "Online · antwoordt direct",
    chatWelcome:
      "Hoi! Ik ben de AI-assistent van 4thscenery. Stel je vraag over onze diensten, onze werkwijze of het plannen van een gratis kennismakingsgesprek.",
    chatPlaceholder: "Typ je vraag…",
    chatError: "Er ging iets mis. Probeer het opnieuw of bel ons via +31 970 065 347.",
    chatAi: "Chat met AI",
    chatSuggestions: [
      "Wat doen jullie precies?",
      "Hoe werkt zo'n kennismakingsgesprek?",
      "Wat kost een website-analyse?",
    ],
  },
  en: {
    heroEyebrow: "Creative marketing agency in the Netherlands",
    navAbout: "About us",
    navServices: "Services",
    navCases: "Projects",
    navTestimonial: "What clients say",
    navBook: "Book a call",
    navFaq: "FAQ",
    heroL1: "We make marketing that works,",
    heroL2: "and automate the rest.",
    heroL3: "No result? No invoice.",
    heroSub:
      "From results-driven marketing to smart software connections. We combine creativity, technology and automation to grow your business.",
    ctaServices: "Explore our services",
    viewService: "View service",
    ctaIntro: "Book an intro call",
    heroFormTitle: "Get in touch",
    heroFormSub: "We'll get back to you within one business day.",
    callNow: "Call now",
    whatsappUs: "WhatsApp us",
    statClients: "clients helped",
    statClientsNote: "From local entrepreneurs to major players",
    statReach: "social media reach & engagement",
    statReachNote: "Combined track record · freelance + 4thscenery",
    marquee: ["Creative content", "Website & SEO", "Automation", "Less manual work", "Marketing that works"],
    chAbout: "About us",
    aboutHeadingA: "We test everything",
    aboutHeadingB: "on ourselves first",
    aboutCopy1:
      "4thscenery is a small, hands-on team. No layers of account managers and no endless reports. We build, test and improve things ourselves. Everything we deploy for clients runs inside our own business first. That's how we know it works.",
    aboutCopy2:
      "Missed call? Our callers instantly get an automatic text back. That way every potential customer is followed up right away and you prevent valuable leads from being lost. We can set up that same system for your organisation and connect it to existing B2B software.",
    aboutChecks: [
      "Instant automatic follow-up",
      "Never lose a lead unnecessarily",
      "Connectable to existing B2B software",
    ],
    smsSystemLabel: "Our SMS automation system",
    smsBadge: "Live example",
    smsTitle: "Missed call",
    smsMessage:
      "Hi! Thanks for calling. We couldn't pick up right away, leave your message here or book a call directly, and we'll get back to you today.",
    smsAuto: "Sent automatically · 4thscenery",
    chServices: "Services",
    servicesHeading: "Marketing, automation & B2B software integration",
    servicesIntro:
      "We help businesses grow with commercials, online ads, conversion-focused websites and smart automations. From automatic lead follow-up via SMS, WhatsApp and email to complete B2B software integrations: we build systems that reduce manual work and make sure fewer leads are lost.",
    servicesLink: "Get advice now",
    services: [
      {
        title: "Commercials + ads",
        copy: "Videos that stick and ads that reach the right people. We write, film and target, you get the enquiries.",
      },
      {
        title: "Website audits",
        copy: "A sharp audit of your website: what works, what's costing you clients and what we improve right away. You get a concrete plan, not a vague report.",
      },
      {
        title: "System building",
        copy: "Automations that never sleep. Missed call? Automatic text. New lead? Instantly followed up. Your calendar fills itself.",
      },
      {
        title: "Conversion-focused websites",
        copy: "Websites that turn visitors into enquiries, built around one goal: conversion.",
      },
      {
        title: "Lead follow-up via SMS, WhatsApp & email",
        copy: "Every lead followed up automatically, right away, on the channel that works.",
      },
      {
        title: "B2B software integrations",
        copy: "Complete connections with your existing B2B software, so your systems work together seamlessly.",
      },
    ],
    noResult: "We take the risk,",
    noInvoice: "you don't.",
    chTestimonial: "What clients say",
    review: "1 review",
    clientOf: "Client of 4thscenery",
    starsLabel: "5 out of 5 stars",
    chBook: "Book a call",
    bookHeading: "Book a call",
    bookCopy:
      "Pick a time that suits you. Fifteen minutes, no strings attached and concrete. You'll always leave with a next step.",
    calLoading: "Loading calendar…",
    calDirect: "Open the planner directly on Cal.com",
    chFaq: "FAQ",
    faqHeading: "Frequently asked questions",
    faqCopy: "Don't see your question? Call, message or email us directly.",
    faq: [
      {
        q: "What's included in your commercials + ads?",
        a: "From concept and script to filming and targeting: we make videos that stick and ads that reach the right people. You get the enquiries.",
      },
      {
        q: "What exactly does a missed-call automation do?",
        a: "Can't pick up? The caller automatically gets a text back within seconds. Every potential customer is followed up instantly and you lose no leads. We connect the system to your existing B2B software.",
      },
      {
        q: "How fast can we start?",
        a: "We start with a free 15-minute intro call. After that you'll know exactly what the next step is and what it will deliver.",
      },
      {
        q: "Do you also work with businesses outside the Randstad?",
        a: "Yes. We work with businesses across the Netherlands, from small local companies to major players.",
      },
      {
        q: "What does a website audit deliver?",
        a: "A sharp audit of your website: what works, what's costing you clients and what we improve right away. You get a concrete plan, not a vague report.",
      },
      {
        q: "Do you also build complete B2B software integrations?",
        a: "Yes. We build integrations that reduce manual work, from automatic lead follow-up via SMS, WhatsApp and email to connections with your existing software.",
      },
    ],
    rowCall: "Call us",
    fName: "Name",
    fPhone: "Phone",
    fEmail: "Email",
    fMsg: "Message",
    phName: "Your name",
    phPhone: "06 12 34 56 78",
    phEmail: "you@company.com",
    phMsg: "How can we help?",
    submit: "Send message",
    sending: "Sending...",
    toastOk: "Thanks! Your message has been sent, we'll respond soon.",
    toastErr: "Sending failed. Please try again or call us directly.",
    closingHeading: "Ready for the next scene?",
    closingCopy: "Call us directly or send a WhatsApp, we respond fast.",
    rights: "All rights reserved.",
    footerTerms: "Terms of Service",
    widgetBubble: "Hi! Send us a message, we usually reply within a few minutes.",
    widgetOnline: "Online",
    widgetStart: "Start chat",
    chatTitle: "4thscenery AI assistant",
    chatOnline: "Online · replies instantly",
    chatWelcome:
      "Hi! I'm the AI assistant of 4thscenery. Ask me anything about our services, the way we work or booking a free intro call.",
    chatPlaceholder: "Type your question…",
    chatError: "Something went wrong. Please try again or call us at +31 970 065 347.",
    chatAi: "Chat with AI",
    chatSuggestions: [
      "What exactly do you do?",
      "How does the intro call work?",
      "What does a website audit cost?",
    ],
  },
};

const LangContext = createContext(null);

export const LangProvider = ({ children }) => {
  const [lang, setLang] = useState("nl");
  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);
  return <LangContext.Provider value={{ lang, setLang, t: STRINGS[lang] }}>{children}</LangContext.Provider>;
};

export const useLang = () => useContext(LangContext);
